export default __webpack_public_path__ + "static/media/typewriterSFX.5582d1c7.mp3";